import React, { useCallback, useState } from "react";
import { getIcon } from "../../utils/iconConfig";
import LogoutandDeleteModal from "./modals/LogoutandDeleteModal/LogoutandDeleteModal";
import ImageModal from "./modals/imageModal/ImageModal";
import { useGlobalContext } from "../../context/GlobalContext";

const GalleryItem = ({ design, hoveredId, setHoveredId, onDelete }) => {
  const { cartData } = useGlobalContext();

  const [deleteModal, setDeleteModal] = useState({ open: false, data: null });

  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imgUrl: null,
    styleNumber: null,
    allData: null,
  });

  const [currentIndex, setCurrentIndex] = useState(
    cartData?.findIndex((item) => item?.styleNumber === design?.styleNumber)
  );

  const isHovered = hoveredId === design?.styleNumber;

  const handleMouseEnter = () => setHoveredId(design?.styleNumber);
  const handleMouseLeave = () => setHoveredId("");

  const handleOpenDeleteModal = useCallback((data) => {
    setDeleteModal({ open: true, data });
  }, []);

  const handleCloseDeleteModal = useCallback(() => {
    setDeleteModal({ open: false, data: null });
  }, []);

  const handleOpenImageModal = useCallback((imgUrl, styleNumber) => {
    setImageModal({ isOpen: true, imgUrl, styleNumber });
  }, []);

  const handleCloseImageModal = useCallback(() => {
    setImageModal({ isOpen: false, imgUrl: null, styleNumber: null });
  }, []);

  const isFirstItem = currentIndex === 0;
  const isLastItem =
    currentIndex === cartData?.length - 1 || cartData?.length === 0;

  const handleNextClick = () => {
    if (currentIndex < cartData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = cartData[newIndex];

      setImageModal({
        isOpen: true,
        imgUrl: nextItem?.imageUrl || null,
        styleNumber: nextItem?.styleNumber,
        allData: nextItem,
      });
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = cartData[newIndex];

      setImageModal({
        isOpen: true,
        imgUrl: prevItem?.imageUrl || null,
        styleNumber: prevItem?.styleNumber,
        allData: prevItem,
      });
    }
  };

  return (
    <>
      {" "}
      <div
        key={design?.styleNumber}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() =>
          handleOpenImageModal(
            design?.imageUrl ? design?.imageUrl : null,
            design?.styleNumber
          )
        }
        style={{
          position: "relative",
          width: "10vw",
          height: "10vw",
          borderRadius: ".25vw",
          overflow: "hidden",
        }}
      >
        <img
          src={design?.transformedImageUrl}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
          }}
        />
        {isHovered && (
          <>
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "#fff",
                padding: ".5vw",
                fontFamily: "Poppins",
                fontSize: ".75vw",
                fontWeight: 500,
              }}
            >
              {design?.styleNumber}
            </div>
            <div
              style={{
                cursor: "pointer",
                position: "absolute",
                top: 15,
                right: 15,
                height: "2vw",
                width: "2vw",
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                borderRadius: ".25vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenDeleteModal(design);
              }}
            >
              {getIcon("dustbin")}
            </div>
          </>
        )}
      </div>
      <LogoutandDeleteModal
        openModal={deleteModal.open}
        handleClose={handleCloseDeleteModal}
        deleteItem={deleteModal?.data}
        onAction={onDelete}
        modalType={"delete"}
      />
      <ImageModal
        openModal={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        nextClick={handleNextClick}
        prevClick={handlePrevClick}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
      />
    </>
  );
};

export default GalleryItem;
